import { Outlet } from 'react-router-dom'
import { TranslationProvider } from './contexts/TranslationContext'
import { GuardProvider } from './guards/GuardContext'
import { I18nProvider } from './i18n/I18nProvider'
import { usePageTracking } from './services/usePageTracking'

export const App = () => {
  usePageTracking();
  return (
    <GuardProvider>
      <TranslationProvider>
        <I18nProvider>
          <Outlet />
        </I18nProvider>
      </TranslationProvider>
    </GuardProvider>
  )
}

